import React from 'react';
import classnames from 'classnames';

const Paragraph = ({ children, className, size = 'large', ...props }) => (
  <p
    className={classnames('leading-loose', className, {
      'my-1 md:my-2 lg:my-4 text-sm': size === 'small',
      'my-3 md:my-4 lg:my-6': size === 'large',
    })}
    {...props}
  >
    {children}
  </p>
);

export default Paragraph;
